// src/api/industryApi.js
import axiosClient from "./axiosClient";

const industryApi = {
  search: (keyword, page, pageSize) => {
    return axiosClient.post(
      `/industry/search`,
      {
        searchKeyword: keyword,
        pageNumber: page > 0 ? page + 1 : 1,
        pageSize: pageSize,
      },
      {
        withCredentials: true,
      },
    );
  },
  searchIndustryChoice: (keyword, page, pageSize, customerId) => {
    return axiosClient.post(
      `/industry/search-industry-choice`,
      {
        searchKeyword: keyword,
        pageNumber: page > 0 ? page + 1 : 1,
        pageSize: pageSize,
        customerId: customerId,
      },
      {
        withCredentials: true,
      },
    );
  },
  getById: (industryId) => {
    return axiosClient.get(`/industry/${industryId}`, {
      withCredentials: true,
    });
  },
  upsert: (data) => {
    return axiosClient.post(
      `/industry/upsert`,
      {
        industryId: data.industryId,
        industryName: data.industryName,
        industryVatRate: data.industryVatRate,
        industryPitRate: data.industryPitRate,
        industryDescription: data.industryDescription,
      },
      {
        withCredentials: true,
      },
    );
  },
  delete: (industryId) => {
    return axiosClient.delete(`/industry/${industryId}`, {
      withCredentials: true,
    });
  },
};

export default industryApi;
